"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeDroitProprieteEnum = {
    ProprietaireUnique: {
        value: "ProprietaireUnique",
        text: "Propriétaire unique"
    },
    IndivisionSimple: {
        value: "IndivisionSimple",
        text: "Indivision simple"
    },
    IndivisionMultiple: {
        value: "IndivisionMultiple",
        text: "Indivision multiple"
    },
    Copropriete: {
        value: "Copropriete",
        text: "Coproriétaire"
    },
    NuProprietaire: {
        value: "NuProprietaire",
        text: "Nu-propriétaire"
    },
    Usufruitier: {
        value: "Usufruitier",
        text: "Usufruitier"
    },
    Autre: {
        value: "Autre",
        text: "Autre"
    }
};
exports.RepriseBranchementElecActionEnum = {
    EncastrerCoffretBranchementCib: {
        value: "EncastrerCoffretBranchementCibe",
        text: "Encastrer 1 coffret de branchement type CIBE"
    },
    EncastrerCoffretBranchementS20: {
        value: "EncastrerCoffretBranchementS20",
        text: "Encastrer 1 coffret de branchement type S20"
    },
    EncastrerCoffretBranchementBorneCibe: {
        value: "EncastrerCoffretBranchementBorneCibe",
        text: "Encastrer 1 coffret de branchement type borne CIBE"
    },
    RaccorderDansCoffretExistant: {
        value: "RaccorderDansCoffretExistant",
        text: "Se raccorder dans le coffret de branchement existant"
    }
};
exports.RepriseBranchementIceActionEnum = {
    Regard30X40CommElectroniques: {
        value: "Regard30X40CommElectroniques",
        text: "Regard 30 cm x 40 cm, pour communications électroniques"
    },
    Regard30X40ReseauxCables: {
        value: "Regard30X40ReseauxCables",
        text: "Regard 30 cm x 40 cm, réseaux câblés"
    },
    RaccorderDansRegardExistant: {
        value: "RaccorderDansRegardExistant",
        text: "Se raccorder dans un regard de visite existant"
    }
};
var TypeReseau;
(function (TypeReseau) {
    TypeReseau["Default"] = "Default";
    TypeReseau["Elec"] = "Elec";
    TypeReseau["EclairagePublic"] = "EclairagePublic";
    TypeReseau["InfraCommunicationElectronique"] = "InfraCommunicationElectronique";
})(TypeReseau = exports.TypeReseau || (exports.TypeReseau = {}));
var TypeOuvrage;
(function (TypeOuvrage) {
    TypeOuvrage["Default"] = "Default";
    TypeOuvrage["LignesEtCoffretsDistribution"] = "LignesEtCoffretsDistribution";
    TypeOuvrage["PosteTransfo"] = "PosteTransfo";
    TypeOuvrage["PosteTransfoEtLigne"] = "PosteTransfoEtLigne";
    TypeOuvrage["RepriseBranchement"] = "RepriseBranchement";
})(TypeOuvrage = exports.TypeOuvrage || (exports.TypeOuvrage = {}));


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/ConventionServitude/Enums/index.ts
// module id = 71
// module chunks = 0